import Vue from 'vue'
export default {
    listeners: [],
    DOMListeners: {},
    hasListener: false,
    listen: function (el, callback) {
        if (!el) {
            this.listeners.push(callback);
            if (!this.hasListener) {
                this.hasListener = true;
                window.addEventListener('scroll', e => this.listeners.map(f => f(e)));
            }
        } else {
            if (!this.DOMListeners[el]) this.DOMListeners[el] = [];
            if (!this.DOMListeners[el].length) document.querySelector(el).addEventListener('scroll', e => this.DOMListeners[el].map(f => f(e)));
            this.DOMListeners[el].push(callback);
        }
    }
}



// WEBPACK FOOTER //
// ./src/helpers/scroll/index.js